import React, { useState } from 'react'
import authorLoginStyle from './AuthorLoginPage.module.css'
import AuthorRagistrationPage from './AuthorRagistrationPage'
import logo from '../../../assets/images/brandlogo.png'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FaUserLarge } from "react-icons/fa6";
import { FaLock } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import axios from "axios";
import Swal from "sweetalert2";
require('typeface-poppins')

export default function AuthorLoginPage() {

	// Eye	
	const [isPasswordVisible, setPasswordVisible] = useState(false);
	const togglePasswordVisibility = () => {
		setPasswordVisible(!isPasswordVisible);
	};

	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState(null); // To handle error messages
	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();

		setError(null); // Reset error message	

		const requestData = {
			email,
			password,
		};

		//	try {
		const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/author_login.php`, requestData);

		if (response.data.success == true) {
			const userId = response.data.user;

			Swal.fire({
				title: "Login Successful!",
				text: "Redirecting to your profile...",
				icon: "success",
				timer: 2000, // Pop-up duration in milliseconds
				showConfirmButton: false, // No need for a confirmation button
			}).then(() => {
				// Redirect after pop-up
				navigate(`/AuthorEditPage/${userId}`);
			});
		} else if (response.data.success1 == false) {
			alert(response.data.message);
		} else {
			alert('User Id Required');
		}

		//   if (response.data.success) {
		// 	if(response.data.success==true){
		// 	const userId = response.data.user;
		// 	setUser(response.data.user); 
		// 	navigate(`/AuthorEditPage/${userId}`);
		// 	}
		// 	else{
		// 	setError(error.response.data.message || response.data.message);
		// 	}

		//   }
		// } catch (error) {
		//   if (error.response) {
		// 	setError(error.response.data.message || 'Login failed');
		//   } else {
		// 	// Network error
		// 	setError('An error occurred. Please try again later.');
		//   }

		// }
	};

	return (
		<>
			<div className={authorLoginStyle.authincationMain}>
				<div className="container h-100">
					<div className="row justify-content-center h-100 align-items-center">
						<div className="col-md-6">
							<div className={authorLoginStyle.authincationContent}>
								<div className="row no-gutters">
									<div className="col-xl-12">
										<div className={authorLoginStyle.authForm}>
											<div className="text-center mb-3">
												<a href="#" className={authorLoginStyle.brandLink}>
													<img src={logo} alt="BrandLogo" />
													<div className={authorLoginStyle.brandInfo}>
														<span> AuthorMeet </span>
														<small> Powered by: &nbsp; Bookworm Central </small>
													</div>
												</a>
											</div>
											<h4 className={authorLoginStyle.brandTitle}> Authors Sign in </h4>
											<form onSubmit={handleSubmit}>
												<div className={`${authorLoginStyle.inputIconboxes} input-group mb-4`}>
													<span className={`${authorLoginStyle.inputIcon} input-group-text`}>
														<FaUserLarge className={authorLoginStyle.primaryColor} />
													</span>
													<input type="email" value={email} className={`${authorLoginStyle.inputFeild} form-control`} placeholder="Email Address" onChange={(e) => setEmail(e.target.value)} required />
												</div>
												<div className={`${authorLoginStyle.inputIconboxes} input-group mb-3`}>
													<span className={`${authorLoginStyle.inputIcon} input-group-text`}>
														<FaLock className={authorLoginStyle.primaryColor} />
													</span>
													<input type={isPasswordVisible ? "text" : "password"} className={`${authorLoginStyle.inputFeild} form-control`} placeholder="Password" onChange={(e) => setPassword(e.target.value)} required />
													<div className={authorLoginStyle.toggleButton} onClick={togglePasswordVisibility}>
														{isPasswordVisible ? <FaEyeSlash className={authorLoginStyle.eyeIcon} /> : <FaEye className={authorLoginStyle.eyeIcon} />}
													</div>
												</div>
												<div className={`${authorLoginStyle.forgotPassword} form-group text-center mb-3`}>
													<a href="#"> Forgot Password? </a>
												</div>
												<div className="form-row d-flex justify-content-between mt-3 mb-3 d-none d-lg-block">
													<div className="form-group">
														<div className="custom-control custom-checkbox ml-1">
															<input type="checkbox" className="custom-control-input me-2" id="" />
															<label className={`${authorLoginStyle.rememberMe} custom-control-label`}> Remember me </label>
														</div>
													</div>
												</div>
												<div className={`${authorLoginStyle.newAccount} ${authorLoginStyle.mobilnewAccount} mb-4 mt-5`}>
													<p className='mb-0'> Create new account? <Link to="/AuthorRagistrationPage" element={<AuthorRagistrationPage />}> Register here </Link></p>
												</div>
												<div className="text-center">
													{error && <p style={{ color: 'red' }}>{error}</p>}
													<button type="submit" className={`${authorLoginStyle.authorSigninBtn} btn btn-warning`}>Login</button>
												</div>
											</form>
											<div className={`${authorLoginStyle.newAccount} ${authorLoginStyle.desktopnewAccount}`}>
												<p className='mb-0'> Create new account? <Link to="/AuthorRagistrationPage" element={<AuthorRagistrationPage />}> Sign Up </Link></p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
